module.exports = __webpack_public_path__ + "files/1afd6376914652ce8c0eaf2f0cc2980b.png";